// extracted by mini-css-extract-plugin
export default {"mid":"Mid_mid__rezoL","left":"Mid_left__Mx09H","right":"Mid_right__1aGqo","rightLine":"Mid_rightLine__0EOaF"};